import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

const AuditLogsService = Services.auditLogs;
export default {
  [VT.AUDIT_LOGS_LIST]: ({ commit, state }, page = 1) => {
    state.auditLogsList['status'] = statuses.LOADING;
    AuditLogsService.list(page).then((data) => {
      commit(VT.AUDIT_LOGS_LIST, data);
    }).catch((errResponse) => {
      commit(VT.AUDIT_LOGS_LIST, errResponse);
    });
  },
};
